import contactSideBarFields from 'molecules/ContactSideBar/config';

import type { Input } from '@builder.io/sdk';

const techSupportFields = [
  {
    name: 'title',
    type: 'string',
  },
  {
    name: 'formId',
    type: 'string',
  },
  {
    name: 'addPadding',
    type: 'boolean',
    defaultValue: 'false',
  },
  {
    name: 'formFields',
    type: 'list',
    subFields: [
      {
        name: 'type',
        type: 'string',
        enum: ['text', 'email', 'textarea', 'tel', 'state', 'select'],
        defaultValue: 'text',
      },
      {
        name: 'fieldName',
        type: 'string',
      },
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'helpText',
        type: 'string',
      },
      {
        name: 'required',
        type: 'boolean',
        defaultValue: false,
      },
      {
        name: 'options',
        type: 'list',
        defaultValue: [],
        showIf: "options.get('type') === 'select'",
        subFields: [
          {
            name: 'abbreviation',
            type: 'string',
          },
          {
            name: 'name',
            type: 'string',
          },
        ],
      },
    ],
  },
  {
    name: 'url',
    friendlyName: 'form_url_old',
    type: 'url',
  },
  {
    name: 'redirect_url',
    type: 'url',
  },
  {
    name: 'form_url',
    friendlyName: 'form_url_pending',
    type: 'object',
    subFields: [
      {
        name: 'dev_url',
        friendlyName: 'dev',
        type: 'url',
      },
      {
        name: 'qa_url',
        friendlyName: 'qa',
        type: 'url',
      },
      {
        name: 'staging_url',
        friendlyName: 'uat',
        type: 'url',
      },
      {
        name: 'production_url',
        friendlyName: 'prod',
        type: 'url',
      },
    ],
  },
  {
    name: 'contactSideBar',
    type: 'object',
    subFields: [...contactSideBarFields],
  },
] as const satisfies DeepReadonly<Input[]>;

const techSupportConfig = {
  name: 'Tech Support',
  inputs: techSupportFields,
};

export type TechSupportProps = GenerateBuilder<typeof techSupportFields>;

export default techSupportConfig;
